import React, { useState } from "react";
import "./PAMMWithdrawalHistory.css";
import { Eye, Download, CheckCircle, XCircle } from "lucide-react";

function PAMMWithdrawalHistory() {
  const [withdrawals] = useState([
    { id: 1, requestId: "WD-2025-001", clientName: "John Doe", accountNo: "PAMM-001", amount: "$5,000", requestDate: "2025-11-20", processDate: "2025-11-21", paymentMethod: "Bank Transfer", status: "Completed" },
    { id: 2, requestId: "WD-2025-002", clientName: "Jane Smith", accountNo: "PAMM-002", amount: "$12,000", requestDate: "2025-11-22", processDate: "-", paymentMethod: "Wire Transfer", status: "Pending" },
    { id: 3, requestId: "WD-2025-003", clientName: "Mike Johnson", accountNo: "PAMM-003", amount: "$3,500", requestDate: "2025-11-18", processDate: "2025-11-19", paymentMethod: "Crypto (USDT)", status: "Completed" },
    { id: 4, requestId: "WD-2025-004", clientName: "Sara Lee", accountNo: "PAMM-004", amount: "$8,200", requestDate: "2025-11-23", processDate: "-", paymentMethod: "Bank Transfer", status: "Processing" },
    { id: 5, requestId: "WD-2025-005", clientName: "Tom Wilson", accountNo: "PAMM-005", amount: "$2,000", requestDate: "2025-11-15", processDate: "2025-11-15", paymentMethod: "Bank Transfer", status: "Rejected" },
  ]);

  const getStatusClass = (status) => {
    switch (status) {
      case "Completed": return "success";
      case "Pending": return "warning";
      case "Processing": return "info";
      case "Rejected": return "danger";
      default: return "";
    }
  };

  return (
    <div className="pamm-withdrawal-container">
      {/* Page Header */}
      <div className="page-header">
        <div className="header-left">
          <h1>PAMM Withdrawal History</h1>
          <div className="header-bottom">
            <h2 className="view-all">View all PAMM withdrawal requests and history</h2>
          </div>
        </div>
        <div className="header-right">
          <button className="btn orange">Export to Excel</button>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="stats-row">
        <div className="stat-card">
          <h3>Total Withdrawals (MTD)</h3>
          <p className="stat-value">$185,500</p>
        </div>
        <div className="stat-card">
          <h3>Completed</h3>
          <p className="stat-value success">$142,000</p>
        </div>
        <div className="stat-card">
          <h3>Pending</h3>
          <p className="stat-value warning">$35,500</p>
        </div>
        <div className="stat-card">
          <h3>Processing</h3>
          <p className="stat-value info">$8,000</p>
        </div>
      </div>

      {/* Filters Section */}
      <div className="filters">
        <input type="text" placeholder="Search by Request ID, Client Name, Account No" />
        <button className="btn">Reset Filters</button>
      </div>

      {/* Filter Row */}
      <div className="filter-row">
        <select>
          <option>Status</option>
          <option>Completed</option>
          <option>Pending</option>
          <option>Processing</option>
          <option>Rejected</option>
        </select>
        <select>
          <option>Payment Method</option>
          <option>Bank Transfer</option>
          <option>Wire Transfer</option>
          <option>Crypto (USDT)</option>
          <option>Crypto (BTC)</option>
        </select>
        <input type="date" placeholder="Start Date" />
        <input type="date" placeholder="End Date" />
        <button className="btn">Apply Filter</button>
      </div>

      {/* Table */}
      <div className="table-container">
        <table className="pamm-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Request ID</th>
              <th>Client Name</th>
              <th>Account No</th>
              <th>Amount</th>
              <th>Request Date</th>
              <th>Process Date</th>
              <th>Payment Method</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {withdrawals.map((withdrawal, index) => (
              <tr key={withdrawal.id}>
                <td>{index + 1}</td>
                <td className="request-id">{withdrawal.requestId}</td>
                <td>{withdrawal.clientName}</td>
                <td>{withdrawal.accountNo}</td>
                <td className="amount">{withdrawal.amount}</td>
                <td>{withdrawal.requestDate}</td>
                <td>{withdrawal.processDate}</td>
                <td>{withdrawal.paymentMethod}</td>
                <td>
                  <span className={`status ${getStatusClass(withdrawal.status)}`}>
                    {withdrawal.status}
                  </span>
                </td>
                <td>
                  <button className="icon-btn" title="View Details">
                    <Eye size={18} />
                  </button>
                  {withdrawal.status === "Pending" && (
                    <>
                      <button className="icon-btn approve" title="Approve">
                        <CheckCircle size={18} />
                      </button>
                      <button className="icon-btn reject" title="Reject">
                        <XCircle size={18} />
                      </button>
                    </>
                  )}
                  <button className="icon-btn" title="Download Receipt">
                    <Download size={18} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="pagination">
        <button className="page-btn">Previous</button>
        <span className="page-info">Page 1 of 10</span>
        <button className="page-btn">Next</button>
      </div>

      {/* Footer */}
      <footer className="footer">
        <p>Copyright © 2025 <span className="brand">Trade Fx Online Solutions</span>. All rights reserved.</p>
        <span className="version">Version 2.0</span>
      </footer>
    </div>
  );
}

export default PAMMWithdrawalHistory;
